// Incoming flight data for the FlightBridge sync modal
// Matches the DB record for allocation a110c380-0009-4000-a000-000000000001

export const ARRIVAL_FLIGHT = {
  allocationId: 'a110c380-0009-4000-a000-000000000001',
  transientStayId: 'd5a12380-0009-4000-a000-000000000001',
  aircraftId: 'c5c9daec-9a77-432c-aa99-d08f5aa0f9fd',

  // Display info
  tailNumber: '000022',
  typeLabel: 'Bombardier Global 8000',
  clientName: 'JetWing Executive Aviation',
  origin: 'CYYZ',  // Toronto Pearson

  // ETA: today at ~22:00 UTC (seeded as 2026-04-04T02:00:00Z = April 3 evening EST)
  etaLabel: 'Today, 10:00 PM',
  checkIn: '2026-04-04T02:00:00Z',
  checkOut: '2026-04-07T12:00:00Z',
  nights: 3,

  // Physical dimensions — shown in the modal "challenge" badge
  wingspanFt: 104,
  lengthFt: 111,
  heightFt: 27,
  category: 'ultra_long_range',

  // Rate
  ratePerNight: 3200,
  totalRevenue: 9600,

  // Position on ramp (pre-placed in DB, just need to make it visible)
  rampPosition: [552, 0, -666] as [number, number, number],
  rampRotation: 270, // facing toward hangar door (west)
} as const
